export enum TextOverflowWrap {
  BreakWord = 'break-word',
  Normal = 'normal'
}
